import React from "react";

import type { DefaultComponent } from "@loadable/component";
import loadable from "@loadable/component";

import { LoadingPage } from "../LoadingPage";

// todo @ zaaslam: [TODO_SDK] See if there is a better way to export this so
// that consumers always use this as "loadable"
/**
 * Loadable helper for pages with some defaults configured
 * Note: Make sure to import this as "loadable" for their babel plugin to
 * process this correctly for dynamic code-splitting
 * @param loader
 */
export function loadablePage<T>(loader: (props: T) => Promise<DefaultComponent<T>>) {
  return loadable(loader, {
    fallback: <LoadingPage />,
  });
}
